import { IPolicyMotorDetails } from '..';

export const mapDataToFormValues = (data: IPolicyMotorDetails) => ({
  ...data,
  plateCode: data?.plateCode?.Code,
  usageType: data?.usageType?.Code,
  bodyType: data?.bodyType?.Code,
  engineType: data?.engineType?.Code,
  make: data?.make.Code,
  model: data?.model.Code,
  color: data?.color.Code,
});
